import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const favoriteProviderStarted = () => {
  return {
    type: actionTypes.FAVORITE_PROVIDER_STARTED,
  };
};
export const favoriteProviderSuccess = (favoriteId) => {
  return {
    type: actionTypes.FAVORITE_PROVIDER_SUCCESS,
    action: favoriteId,
  };
};
export const favoriteProviderError = () => {
  return {
    type: actionTypes.FAVORITE_PROVIDER_ERROR,
  };
};
export const unFavoriteProviderStarted = () => {
  return {
    type: actionTypes.UNFAVORITE_PROVIDER_STARTED,
  };
};
export const unFavoriteProviderSuccess = (favoriteId) => {
  return {
    type: actionTypes.UNFAVORITE_PROVIDER_SUCCESS,
    action: favoriteId,
  };
};
export const unFavoriteProviderError = () => {
  return {
    type: actionTypes.UNFAVORITE_PROVIDER_ERROR,
  };
};
export const resetUnFavoriteProvider = () => {
  return {
    type: actionTypes.RESET_UNFAVORITE_PROVIDER_SUCCESS,
  };
};
export const resetFavoriteProvider = () => {
  return {
    type: actionTypes.RESET_FAVORITE_PROVIDER_SUCCESS,
  };
};
export const favoriteProvider = (
  providerId: number,
  npi: string,
  postalCode: string
) => {
  const favProvider = {
    userId: localStorage.getItem("userId"),
    providerId: providerId,
    postalCode: postalCode,
    npi: npi,
    clientId: localStorage.getItem("clientId"),
    clientGroupId: localStorage.getItem("clientGroupId"),
  };
  return (dispatch) => {
    dispatch(favoriteProviderStarted());
    axios
      .post(serverconfigs.favoriteProviderUrl, favProvider)
      .then((response) => {
        console.log(response.data);
        dispatch(favoriteProviderSuccess(response.data["favoriteId"]));
      })
      .catch((error) => {
        dispatch(favoriteProviderError());
      });
  };
};

export const unfavoriteProvider = (favoriteId: string) => {
  return (dispatch) => {
    dispatch(unFavoriteProviderStarted());
    axios
      .put(serverconfigs.favoriteProviderUrl + `/${favoriteId}`)
      .then((response) => {
        console.log(`/provider/favorite/${favoriteId}`);
        console.log("favorite response is", response.data);
        dispatch(unFavoriteProviderSuccess(response.data["favoriteId"]));
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        dispatch(unFavoriteProviderError());
      });
  };
};
